<template>
	<div class="row dynvibeSearch">
		<div class="col-lg-3">
			<div class="row" style="margin-left: 5px">
				<label class="labelRadio col-lg-4"
					>ALL
					<input type="radio" v-model="typemastertag" value="all" checked />
					<span class="checkmark"></span>
				</label>

				<label class="labelRadio col-lg-4"
					>TOPICS
					<input type="radio" v-model="typemastertag" value="tag" />
					<span class="checkmark"></span>
				</label>
			</div>
			<div class="row" style="margin-left: 5px">
				<label class="labelRadio col-lg-4"
					>BRANDS
					<input type="radio" v-model="typemastertag" value="brand" />
					<span class="checkmark"></span>
				</label>
				<label class="labelRadio col-lg-4"
					>TRENDS
					<input type="radio" v-model="typemastertag" value="trends" />
					<span class="checkmark"></span>
				</label>
			</div>
		</div>
		<div id="dynvibeSearchFiltersBase" class="col-lg-3">
			<select id="dynvibeListCategory" class="dynvibeListCategory col-lg-12" v-model="selectedPanel">
				<option value="">Choose Panel</option>
				<option v-for="(item, index) in panels" :key="index">
					{{ item._source.label }}
				</option>
			</select>
		</div>
		<div id="dynvibeSearchFiltersBase" class="col-lg-6">
			<div class="row col-lg-6">
				<select v-if="displayCat" class="col-lg-12 dynvibeListCategory" id="dynvibeListCategory" v-model="selectedCategory">
					<option value="">Choose Category</option>
					<option v-for="(item, index) in categories" :key="index">
						{{ item }}
					</option>
				</select>
				<select
					v-if="displaySubCat"
					class="col-lg-12 dynvibeListSubcategory"
					id="dynvibeListSubcategory"
					v-model="selectedSubCategory"
				>
					<option value="">Choose SubCategory</option>
					<option v-for="(item, index) in subcategories" :key="index">
						{{ item }}
					</option>
				</select>
			</div>
			<div class="row col-lg-6" style="padding-left: 40px">
				<select v-if="displayTopics" class="col-lg-12 dynvibeListMastertags" id="dynvibeListMastertags" v-model="selectedMastertag">
					<option value="">Choose Mastertag</option>
					<option v-for="(item, index) in mastertags" :key="index">
						{{ item }}
					</option>
				</select>
				<select v-if="displayTrends" class="col-lg-12 dynvibeListMastertags" id="dynvibeListMastertags" v-model="selectedTrend">
					<option value="">Choose Trend</option>
					<option v-for="(item, index) in trends" :key="index">
						{{ item.label }}
					</option>
				</select>
				<span class="dynvibeSearchInputResetFilters" title="Reset filters" @click="resetFilter()" style="float: right"
					>Reset Filters</span
				>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "explorefilters",
	props: {
		selectedDate: {
			type: Object,
			default: function () {
				return {};
			},
		},
	},
	data() {
		return {
			typemastertag: "all",
			selectedCategory: "",
			selectedSubCategory: "",
			selectedMastertag: "",
			selectedTrend: "",
			emitCategory: "",
			emitSubCategory: "",
			emitMastertag: "",
			emitTrend: "",
			categories: [],
			subcategories: [],
			mastertags: [],
			trends: [],
			reset: false,
			panels: [],
			selectedPanel: "",
			emitPanel: "",
			displayCat: true,
			displaySubCat: true,
			displayTopics: true,
			displayTrends: true,
		};
	},
	emits: ["trendfilters"],
	mounted() {
		// this.$axios.get("getListTrends").then((response) => {
		// 	this.trends = response.data.data.map(x=>x._source)
		// });
		this.$axios.get(this.$backendUrl + "trendFilter").then((response) => {
			this.panels = response.data.panels;
			this.categories = response.data.categories;
			this.subcategories = response.data.subcategories;
			this.mastertags = response.data.mastertags;
			this.trends = response.data.trends.map((x) => x._source);
		});
	},
	methods: {
		reload(resp) {
			if (resp.val.category != null) {
				this.emitCategory = resp.val.category.key;
				this.emitSubCategory = "";
				this.emitMastertag = "";
				this.emitTrend = "";
				if (resp.val.subcategory == null) {
					this.selectedSubCategory = "";
				}
				if (resp.val.mastertag == null) {
					this.selectedMastertag = "";
				}
				if (resp.val.trend == null) {
					this.selectedTrend = "";
				}
			} else {
				this.emitCategory = "";
				this.selectedCategory = "";
				this.emitSubCategory = "";
				this.emitMastertag = "";
				this.emitTrend = "";
				if (resp.val.subcategory == null) {
					this.selectedSubCategory = "";
				}
				if (resp.val.mastertag == null) {
					this.selectedMastertag = "";
				}
				if (resp.val.trend == null) {
					this.selectedTrend = "";
				}
			}

			if (resp.val.subcategory != null) {
				this.emitSubCategory = resp.val.subcategory.key;
				this.emitMastertag = "";
				this.emitTrend = "";
				this.selectedMastertag = "";
			}

			if (resp.val.mastertag != null) {
				this.emitMastertag = resp.val.mastertag.key;
				this.emitTrend = "";
				this.selectedTrend = "";
			}

			if (resp.val.trend != null) {
				this.emitTrend = resp.val.trend.key;
			}
			this.checkFilter();
		},
		resetFilter() {
			this.reset = true;
			this.$emit("trendfilters", {
				category: "",
				subcategory: "",
				mastertag: "",
				trend: "",
				//date:"",
				typemastertag: "all",
				date: this.selectedDate,
				age: [],
				gender: [],
				sources: [],
				country: [],
				reset: true,
				panel: "",
				listFilters: false,
			});
			// axios.get("getListTrends").then((response) => {
			// 	this.trends = response.data.data.map(x=>x._source)
			// });
			// axios.get("trendFilter").then((response) => {

			// 	this.categories = response.data.categories;
			// 	this.subcategories = response.data.subcategories;
			// 	this.mastertags = response.data.mastertags;
			// 	// this.trends = response.data.trends.map(x=>x._source)
			// });
			this.selectedCategory = "";
			this.selectedSubCategory = "";
			this.selectedMastertag = "";
			this.selectedTrend = "";
			this.emitCategory = "";
			this.emitSubCategory = "";
			this.emitMastertag = "";
			this.emitTrend = "";
			this.selectedPanel = "";
			this.emitPanel = "";
			this.typemastertag = "all";
			this.reset = false;
		},
		checkFilter(listFilters = false) {
			this.reset = false;

			if (this.typemastertag === "brand") {
				this.emitCategory = "Brands";
			}
			if (this.emitCategory != "" || this.emitSubCategory != "" || this.emitMastertag != "" || this.emitTrend != "") {
				listFilters = true;
			}

			if (this.emitCategory == "" && this.emitSubCategory == "" && this.emitMastertag == "" && this.emitTrend == "") {
				listFilters = false;
			}

			//let country = this.selectedCountry == "" ? {} : this.selectedCountry;
			this.$emit("trendfilters", {
				category: this.emitCategory,
				subcategory: this.emitSubCategory,
				mastertag: this.emitMastertag,
				trend: this.emitTrend,
				date: this.selectedDate,
				typemastertag: this.typemastertag,
				reset: this.reset,
				panel: this.emitPanel,
				listFilters: listFilters,
			});
			this.displaySelect();
		},
		displaySelect() {
			this.displayCat = true;
			this.displaySubCat = true;
			this.displayTopics = true;
			this.displayTrends = true;
			if (this.typemastertag === "brand") {
				this.displayCat = false;
				this.displayTrends = false;
			} else if (this.typemastertag === "tag") {
				this.displayTrends = false;
			} else if (this.typemastertag === "trends") {
				this.displaySubCat = false;
				this.displayTopics = false;
			}
		},
	},
	watch: {
		selectedDate: {
			deep: true,
			handler() {
				this.checkFilter();
			},
		},
		typemastertag: function () {
			this.selectedCategory = "";
			this.selectedSubCategory = "";
			this.selectedMastertag = "";
			this.selectedTrend = "";
			this.emitCategory = "";
			this.emitSubCategory = "";
			this.emitMastertag = "";
			this.emitTrend = "";
			this.checkFilter();
			this.$axios
				.get(this.$backendUrl + "trendFilter", {
					params: {
						typemastertag: this.typemastertag,
					},
					paramsSerializer: (params) => {
						return this.$Qs.stringify(params, { arrayFormat: "brackets" });
					},
				})
				.then((response) => {
					this.panels = response.data.panels;
					this.categories = response.data.categories;
					this.subcategories = response.data.subcategories;
					this.mastertags = response.data.mastertags;
					this.trends = response.data.trends.map((x) => x._source);
				});
		},
		selectedPanel: function (val) {
			if (this.reset == false) {
				this.emitPanel = this.selectedPanel;
				if (val != "") {
					this.checkFilter();
				}
			}
		},
		selectedCategory: function (val) {
			if (this.reset == false) {
				this.$axios
					.get(this.$backendUrl + "trendFilter", {
						params: {
							type: "cat",
							label: this.selectedCategory,
							typemastertag: this.typemastertag,
						},
						paramsSerializer: (params) => {
							return this.$Qs.stringify(params, { arrayFormat: "brackets" });
						},
					})
					.then((response) => {
						this.subcategories = response.data.subcategories;
						this.mastertags = response.data.mastertags;
						if (Object.prototype.hasOwnProperty.call(response.data, "trends")) {
							this.trends = response.data.trends.map((x) => x._source);
						} else {
							this.trends = [];
						}
					});
				this.emitCategory = this.selectedCategory;
				this.emitSubCategory = "";
				this.emitMastertag = "";
				this.emitTrend = "";
				this.selectedSubCategory = "";
				this.selectedMastertag = "";
				this.selectedTrend = "";
				if (val != "") {
					this.checkFilter(true);
				}
			}
		},
		selectedSubCategory: function (val) {
			if (this.reset == false) {
				this.$axios
					.get(this.$backendUrl + "trendFilter", {
						params: {
							type: "subcat",
							label: this.selectedSubCategory,
							typemastertag: this.typemastertag,
						},
						paramsSerializer: (params) => {
							return this.$Qs.stringify(params, { arrayFormat: "brackets" });
						},
					})
					.then((response) => {
						this.mastertags = response.data.mastertags;
						if (Object.prototype.hasOwnProperty.call(response.data, "trends")) {
							this.trends = response.data.trends.map((x) => x._source);
						} else {
							this.trends = [];
						}
					});

				this.emitCategory = "";
				this.emitSubCategory = this.selectedSubCategory;
				this.emitMastertag = "";
				this.emitTrend = "";
				this.selectedMastertag = "";
				this.selectedTrend = "";
				if (val != "") {
					this.checkFilter(true);
				}
			}
		},
		selectedMastertag: function (val) {
			if (this.reset == false) {
				this.$axios
					.get(this.$backendUrl + "trendFilter", {
						params: {
							type: "mt",
							label: this.selectedMastertag,
							typemastertag: this.typemastertag,
						},
						paramsSerializer: (params) => {
							return this.$Qs.stringify(params, { arrayFormat: "brackets" });
						},
					})
					.then((response) => {
						if (Object.prototype.hasOwnProperty.call(response.data, "trends")) {
							this.trends = response.data.trends.map((x) => x._source);
						} else {
							this.trends = [];
						}
					});
				this.emitCategory = "";
				this.emitSubCategory = "";
				this.emitMastertag = this.selectedMastertag;
				this.emitTrend = "";
				if (val != "") {
					this.checkFilter(true);
				}
			}
		},
		selectedTrend: function (val) {
			// console.log(this.selectedTrend)
			if (this.reset == false) {
				this.emitCategory = "";
				this.emitSubCategory = "";
				this.emitMastertag = "";
				this.emitTrend = this.selectedTrend;
				if (val != "") {
					this.checkFilter(true);
				}
			}
		},
	},
};
</script>
<style scoped>
.dynvibeSearch {
	align-items: flex-start;
	padding-top: 15px;
	padding-bottom: 15px;
}

/* INPUT RADIO */
.labelRadio {
	display: inline;
	position: relative;
	padding-left: 20px;
	margin-right: 10px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelRadio input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkmark {
	position: absolute;
	top: 2px;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #fff;
	border-radius: 50%;
	border: 1px solid #33d1cd;
}

/* On mouse-over, add a grey background color */
.labelRadio:hover input ~ .checkmark {
	background-color: rgba(51, 209, 205, 0.2);
}

/* When the checkbox is checked, add a blue background */
.labelRadio input:checked ~ .checkmark {
	background-color: #33d1cd;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

/* Show the checkmark when checked */
.labelRadio input:checked ~ .checkmark:after {
	display: block;
}

.labelCheckbox {
	display: inline;
	position: relative;
	padding-left: 25px;
	margin-right: 10px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelCheckbox input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}
</style>
